// usage.actions.js
import { GET_USAGE } from "adapters/ehr.service";
import { constants } from "../constants/redux-constants";

export const fetchUsage = () => async (dispatch) => {
  dispatch({ type: constants.PLANS_USAGE.FETCH_USAGE_REQUEST });
  try {
    const response = await GET_USAGE();
    dispatch({
      type: constants.PLANS_USAGE.FETCH_USAGE_SUCCESS,
      payload: response,
    });
    return response
  } catch (error) {
    dispatch({
      type: constants.PLANS_USAGE.FETCH_USAGE_FAILURE,
      payload: error.message,
    });
  }
};
